import React, { useEffect } from "react";
import {
  withStyles,
  Dialog,
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  CircularProgress,
  MenuItem,
  Button,
  DialogContent,
  DialogContentText,
  DialogTitle,
  DialogActions,
} from "@material-ui/core";

export default function Confirm({
  name,
  isOpen,
  title,
  content,
  onConfirm,
  onCancel,
  confirm,
  cancel,
  classes,
  extentions,
  preStyledContent,
  innerHtmlContent
}) {
  return (
    <Dialog
      key={name}
      open={isOpen}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      class="dialogBox"
    >
      <DialogTitle id="alert-dialog-title">{title}</DialogTitle>
      {content && (<DialogContent>{content}</DialogContent>)}
      {preStyledContent && (<DialogContent>{preStyledContent}</DialogContent>)}
      {innerHtmlContent && (<DialogContent><span dangerouslySetInnerHTML={{__html: innerHtmlContent}}></span></DialogContent>)}
      
      <DialogActions>
        {onConfirm && confirm && (
          <Button
            class="dialogYesButton"
            onClick={onConfirm}
            color="primary"
            autoFocus
          >
            {confirm}
          </Button>
        )}

        {onCancel && cancel && (
          <Button
            class="dialogNoButton"
            onClick={onCancel}
            color="primary"
          >
            {cancel}
          </Button>
        )}

        { extentions && extentions.map(d=>{
          if(d.action && d.text){
              return (
                <Button
                class="dialogNoButton"
                onClick={d.action}
                color="primary"
                >
                  {d.text}
                </Button>
              )
            }
        }) }
      </DialogActions>
    </Dialog>
  );
}
